const { forEach, remove } = require('lodash'), { createInspirationTiles } = require('./inspiration-tile-factory');

function removeAdsFromTiles(tiles) {
    const ads = [];

    remove(tiles, (tile, index) => {
        if (tile.type !== 'product') return false;

        if (tile.data.product.IsSponsoredAd) {
            ads.push({
                index,
                tile,
            });
        }

        return tile.data.product.IsSponsoredAd;
    });

    return ads;
}

function mergeInspirationTiles(cards, inspirationTiles, { pageNumber, pageSize = Number.MAX_VALUE, type }, enableAdsPosition = false) {
    const ads = enableAdsPosition ? removeAdsFromTiles(cards) : []; // Let ads take priority if the feature switch is on
    const pageOffset = pageNumber != null ? pageSize * (pageNumber - 1) : 0;

    // Merge inspiration cards with actual cards
    forEach(inspirationTiles, (inspTiles, position) => {
        position = parseInt(position, 10) - pageOffset;

        if (position < 0 || position >= pageSize) return;

        Array.prototype.splice.apply(cards, [position, 0]
            .concat(createInspirationTiles(inspTiles, type)));
    });

    // Put ads back to tile with correct position if existed
    if (ads.length > 0) {
        forEach(ads, (ad) => {
            Array.prototype.splice.apply(cards, [ad.index, 0, ad.tile]);
        });
    }

    return cards;
}

module.exports = { mergeInspirationTiles };



// WEBPACK FOOTER //
// ./src/shop/tiles/merge-inspiration-tiles.js